var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6999_145882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 24.0025H2V20.0025H22V24.0025ZM13.06 5.1925L16.81 8.9425L7.75 18.0025H4V14.2525L13.06 5.1925ZM17.88 7.8725L14.13 4.1225L15.96 2.2925C16.35 1.9025 16.98 1.9025 17.37 2.2925L19.71 4.6325C20.1 5.0225 20.1 5.6525 19.71 6.0425L17.88 7.8725Z",
    fill: "url(#paint0_linear_6999_145882)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6999_145882",
    x1: 21.9981,
    y1: 12.8974,
    x2: 0.961509,
    y2: 12.8974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005887"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6999_145882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.0eb8c6034ea545f30a6efdd75a1315d9.svg";
export { ForwardRef as ReactComponent };